class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.querySelector('#MenuDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.querySelector('.header__drawer-link').addEventListener('click', this.close.bind(this));
    this.initializeDrawer();
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    document.body.classList.add('overflow-hidden');
  }
  
  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // Remove the 'open' class and 'link-disabled' class from all drawerItems
    const drawerItems = this.querySelectorAll('.menu-drawer__list li');
    
    drawerItems.forEach(drawerItem => {
      drawerItem.classList.remove('open');
      
      const submenuLink = drawerItem.querySelector('.header__menu-item');
      
      if (submenuLink) {
        submenuLink.classList.add('link-disabled');
      }
    });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  initializeDrawer() {

    const drawerItems = this.querySelectorAll('.menu-drawer__list li');

    drawerItems.forEach(drawerItem => {
      const submenuHeader = drawerItem.querySelector('.drawer__submenu-heading');
    
      if (submenuHeader) {
        const submenuLink = submenuHeader.querySelector('.header__menu-item');
        const submenuContent = drawerItem.querySelector('.header__submenu');
      
        submenuHeader.addEventListener('click', () => {
          if (!drawerItem.classList.contains('open')) {
            // If the item is not open, prevent link click and open it
            submenuLink.classList.remove('link-disabled');
            drawerItem.classList.add('open');
            
            drawerItems.forEach(otherDrawerItem => {
              if (otherDrawerItem !== drawerItem) {
                otherDrawerItem.classList.remove('open');
                otherDrawerItem.querySelector('.header__menu-item').classList.add('link-disabled');
              }
            });
            
          } else {
            // If the item is open, allow link click
            submenuLink.classList.remove('link-disabled');
          }
        });
      }
    });

    
  }

  
}

customElements.define('mobile-menu-drawer', MobileMenuDrawer);


